module.exports = __webpack_public_path__ + "img/icon-instagram.4d84ca3.svg";